var map = {
	"./aks.svg": [
		34827,
		4827
	],
	"./azure-artifacts.svg": [
		72636,
		2636
	],
	"./azure-devops.svg": [
		26002,
		6002
	],
	"./azure-pipelines.svg": [
		65272,
		5272
	],
	"./azure-repos.svg": [
		46723,
		6723
	],
	"./azure-test-plans.svg": [
		70157,
		157
	],
	"./azure.svg": [
		89140,
		9140
	],
	"./browserstack.svg": [
		22101,
		2101
	],
	"./browserstack_app.svg": [
		82824,
		2824
	],
	"./browserstack_appautomate.svg": [
		11804,
		1804
	],
	"./browserstack_automate.svg": [
		15231,
		5231
	],
	"./bug.svg": [
		73426,
		3426
	],
	"./confluence.svg": [
		90894,
		894
	],
	"./copilot.png": [
		54757
	],
	"./copilot.svg": [
		4834,
		4834
	],
	"./deliverable.svg": [
		3834,
		3834
	],
	"./design.svg": [
		44416,
		4416
	],
	"./dotnet.svg": [
		69096,
		9096
	],
	"./epic.svg": [
		13660,
		3660
	],
	"./epics.svg": [
		8906,
		8906
	],
	"./experiment.svg": [
		14105,
		4105
	],
	"./fastapi.png": [
		69061,
		9061
	],
	"./feature.svg": [
		4901,
		4901
	],
	"./figma.svg": [
		75014,
		5014
	],
	"./genAI.png": [
		86573
	],
	"./general-defect.svg": [
		43583,
		3583
	],
	"./github.svg": [
		39351,
		9351
	],
	"./improvement.svg": [
		35349,
		5349
	],
	"./incident.svg": [
		48661,
		8661
	],
	"./jira.svg": [
		96867,
		6867
	],
	"./jira_cloud.svg": [
		23749,
		3749
	],
	"./nestjs.svg": [
		96892,
		6892
	],
	"./new-relic.svg": [
		18564,
		8564
	],
	"./nextjs.svg": [
		19719,
		9719
	],
	"./nodejs.png": [
		47964,
		7964
	],
	"./postgresql.svg": [
		46969,
		6969
	],
	"./precondition.png": [
		97968
	],
	"./qTest.png": [
		92303
	],
	"./risk.svg": [
		62379,
		2379
	],
	"./sonarqube.svg": [
		24802,
		4802
	],
	"./spike.svg": [
		51266,
		1266
	],
	"./splunk.svg": [
		73909,
		3909
	],
	"./story-defect.svg": [
		11885,
		1885
	],
	"./story.svg": [
		47974,
		7974
	],
	"./sub-task.svg": [
		95407,
		5407
	],
	"./sub-test-execution.png": [
		5240
	],
	"./task.svg": [
		21649,
		1649
	],
	"./technical-debt.svg": [
		22027,
		2027
	],
	"./terraform.svg": [
		64264,
		4264
	],
	"./test-execution.png": [
		37489
	],
	"./test-plan.png": [
		5359
	],
	"./test-set.png": [
		40506
	],
	"./test.png": [
		38270
	],
	"./theme.svg": [
		31062,
		3126
	],
	"./tosca.png": [
		98557
	],
	"./user-story.svg": [
		33164,
		3164
	],
	"./xray.svg": [
		31594,
		1594
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 87493;
module.exports = webpackAsyncContext;